export default __webpack_public_path__ + "static/cordyShover-a617bba706ec50763d33ec04c785282a.png";